import Skeleton from '@material-ui/lab/Skeleton'
import type { FC } from 'react'
import React from 'react'
import { makeStyles, createStyles } from '@material-ui/core/styles'
import clsx from 'clsx'
import type { ITheme } from '@homeviews/styles'
import { Card, Typography } from '@homeviews/shared-ui'

const useStyles = makeStyles((theme: ITheme) =>
  createStyles({
    root: {
      marginBottom: theme.spacing(2),
      backgroundColor: '#f9f9f9',
    },
    header: {
      display: 'flex',
    },
    metaSkeleton: {
      width: '25%',
      maxWidth: '100px',
      marginRight: theme.spacing(2),
    },
    metaSkeletonLast: {
      marginLeft: 'auto',
      marginRight: 0,
    },
  }),
)

const ReviewCardSkeleton: FC = () => {
  const classes = useStyles()

  return (
    <Card className={classes.root}>
      <div className={classes.header}>
        <Skeleton className={classes.metaSkeleton} />
        <Skeleton className={classes.metaSkeleton} />
        <Skeleton className={classes.metaSkeleton} />
        <Skeleton className={classes.metaSkeleton} />
        <Skeleton
          className={clsx(classes.metaSkeleton, classes.metaSkeletonLast)}
        />
      </div>
      <Typography variant="h2" style={{ marginBottom: '10px', width: '70%' }}>
        <Skeleton />
      </Typography>
      <Typography>
        <Skeleton />
      </Typography>
      <Typography style={{ width: '100%' }}>
        <Skeleton />
      </Typography>
      <Typography style={{ width: '90%' }}>
        <Skeleton />
      </Typography>
    </Card>
  )
}

export default ReviewCardSkeleton
